import * as types from "../../actions/types";



const initialState = {
  schoolYears: null,
  peoples: null,
  courses: null,
  profiles: null
};


export function filters(state = initialState, action) {
  switch (action.type) {
    case types.SET_DISCIPLINE_STRUCTURE_FILTER:
      return { ...state, ...action.payload };
    case types.SET_DISCIPLINE_STRUCTURE_FILTER_MID:
      return {
        ...state,
        list_mid: action.payload
      }
    case types.SET_DISCIPLINE_STRUCTURE_FILTER_CID:
      return {
        ...state,
        list_cid: action.payload
      }
    case types.SET_DISCIPLINE_STRUCTURE_FILTER_TRP:
      return {
        ...state,
        list_trp: action.payload
      }
    default:
      return state;
  }
}